import Layout from "@/components/blocks/layout/Layout";
import Meta from "@/components/blocks/layout/Meta";
import Header from "@/components/Marketplace/headerMarketplace";
import { ScannerValue } from "@/components/scanners-page";
import PageContent from "@/components/scanners-page/layout/PageContent";
import { useUserContext } from "@/contexts/userContext";

import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";

const MetaTags = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <Meta
      title={title}
      description={description}
      image={{
        url: "/images/scanners/og_scanners.png",
        alt: "Scanner Image",
      }}
    />
  );
};

const Page = () => {
  const router = useRouter();
  const { user } = useUserContext();
  const scanner = useMemo(
    () => router.query.scanner as ScannerValue,
    [router.query.scanner],
  );

  const [userLoggedIn, setUserLogin] = useState(false);
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("user-info") || "null") != null) {
      setUserLogin(true);
    }
  }, []);
  if (!scanner) return <></>;
  return (
    <div className="w-full h-full">
      {userLoggedIn ? (
        <Layout
          meta={""}
          footer={""}
          trainingComponent={""}
          IdeasStream={""}
          hideRiskWarning
          hideSpaceWhenNoRiskWarning
          hideIdeastream
          onScrollBg
        >
          <PageContent userLoggedIn={!!user} scanner={scanner} />
        </Layout>
      ) : (
        <div className="">
          <Header />
          <PageContent userLoggedIn={!!user} scanner={scanner} />
        </div>
      )}
    </div>
  );
};
export default Page;
